<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button class="btn btn-primary btn-back top-back-button"
                            (click)="back()"><i class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Notifications</div>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>

                <div class="row w100 m-auto">
                    <div *ngIf="errorMessage || sucessMessage">
                        <div class="col-12 alert alert-info" role="alert" *ngIf="sucessMessage"> &nbsp;<span
                                [innerHTML]="sucessMessage"></span></div>
                        <div class="col-12 alert alert-danger" role="alert" *ngIf="errorMessage"> &nbsp;<span
                                [innerHTML]="errorMessage"></span></div>
                    </div>
                    <form autocomplete="off" class="w100 text-left mb-b" [formGroup]="notificationForm">
                        <div class="col-12 col-sm-12">

                            <div class="billing-detail">
                                <div class="billing-detail-row">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="rectangle-wrapper display-webkit-box">
                                                <div class="row mt-4">
                                                    <div class="col-12 col-sm-12 ">
                                                        <div id="notificationLabel"
                                                            [ngClass]="(userStoreService?.getUserProfile()?.contactInfo?.phoneNumber) ? 'mb-4' : 'mb-1'">
                                                            METHODS (Choose all options that apply)</div>
                                                        <div id="notificationLabel" class="mb-4 blue-color"
                                                            *ngIf="!userStoreService?.getUserProfile()?.contactInfo?.phoneNumber">
                                                            Provide a mobile number in Contact Info and the Text option
                                                            will be available.</div>
                                                    </div>
                                                    <div class="col-12 ">
                                                        <div class="checkbox-container ml-3">
                                                            <span>Email</span>
                                                            <label class="d-block cursorPonter">
                                                                <input type="checkbox" name="email"
                                                                    formControlName="email">
                                                                <span class="checkmark-default"></span>
                                                            </label>
                                                        </div>


                                                    </div>
                                                    <div class="col-12 ">
                                                        <div class="checkbox-container ml-3"
                                                            [ngClass]="{ 'disabled ':  !userStoreService?.getUserProfile()?.contactInfo?.mobile }">
                                                            <span>Text
                                                                <span class="notationText">Msg & data rates may apply
                                                                </span>
                                                            </span>
                                                            <label class="d-block cursorPonter">
                                                                <input type="checkbox"
                                                                    [attr.disabled]="!userStoreService?.getUserProfile()?.contactInfo?.mobile ? 'disabled' : null"
                                                                    name="text" formControlName="text">
                                                                <span class="checkmark-default"
                                                                    [ngClass]="!userStoreService?.getUserProfile()?.contactInfo?.mobile ? 'checkmark-disabled' : 'checkmark-default'"></span>
                                                            </label>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div class="billing-detail-row">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="rectangle-wrapper display-webkit-box">
                                                <div class="row mt-4">

                                                    <div class="col-12 col-sm-12">
                                                        <div id="notificationLabel" class="mb-4">ALERT</div>
                                                    </div>
                                                    <div class="col-12 col-sm-12">
                                                        <div class="checkbox-container ml-3">
                                                            <span>DMV registration renewal reminder</span>
                                                            <label class="d-block cursorPonter">
                                                                <input type="checkbox" name="dmv"
                                                                    [attr.disabled]="!userStoreService?.getUserProfile()?.billingAccounts?.dmvAccounts?.length ? 'disabled' : null"
                                                                    formControlName="dmv">
                                                                    <span class="checkmark-default"
                                                                    [ngClass]="!userStoreService?.getUserProfile()?.billingAccounts?.dmvAccounts?.length ? 'checkmark-disabled' : 'checkmark-default'"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12" style="display:none">
                                                        <div class="checkbox-container disabled ml-3">
                                                            <span>Property tax reminder</span>
                                                            <label class="d-block cursorPonter">
                                                                <input type="checkbox" disabled name="propertyTax"
                                                                    formControlName="propertyTax">
                                                                <span class="checkmark-default"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12" style="display:none">
                                                        <div class="checkbox-container disabled ml-3">
                                                            <span>Business tax reminder</span>
                                                            <label class="d-block cursorPonter">
                                                                <input type="checkbox" disabled name="businessTax"
                                                                    formControlName="businessTax">
                                                                <span class="checkmark-default"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div *ngIf="!sucessMessage" class="container m-auto text-center"><a><button class="btn btn-primary btn-back"
                        (click)="cancel()">Cancel</button></a><a><button class="btn btn-primary  btn-continue m-auto"
                        (click)="save()">Save</button></a></div>
            <div *ngIf="sucessMessage" class="container m-auto text-center"><a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="cancel()">Close</button></a></div>
        </div>
    </div>
</div>